import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import LandingPageAppBar from "../components/LandingPageAppBar";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { viewSpecificModuleAction } from "../redux/actions/courseActions";
import { Breadcrumb } from "antd";
import Footer from "../components/common/Footer";
import MobileFooter from "../components/common/MobileFooter";
import Helmet from 'react-helmet';

import CoursePage from "./CoursePage";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const ModulePage = ({ viewSpecificModuleAction, moduleState, match }) => {
  const [isLoading, setLoader] = useState(true);

  const classes = useStyles();
  const courseName = match.params.courseName;
  const moduleName = match.params.moduleName;

  const getAllModules = () => {
    viewSpecificModuleAction(courseName, moduleName);
  };
  useEffect(() => {
    getAllModules();
    if (moduleState.singleModuleData) {
      setLoader(false);
    }
  }, []);

  return (
    <div className="container">
      <Helmet title={`${courseName} > ${moduleName}`}/>
      <LandingPageAppBar />
      <div className="container-column" >
          <div className="container-dft-margin" >
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/">Courses</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={`/courses/${courseName}`}>{courseName}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link
                  to={`/courses/${courseName}/${moduleState.singleModuleData?.data.name}`}
                >
                  {moduleState.singleModuleData?.data.name}
                </Link>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
{/* <CoursePage> */}
        <div className="container-row container-100">
          <div className="body-container content-container">
            <div className="container-column">
              <label className="big-title">{courseName}</label>
              {/* Display module name here */}
              <label className="sub-title">
                {moduleState.singleModuleData?.data ? (
                  <strong>
                    Module: {moduleState.singleModuleData?.data.name}
                  </strong>
                ) : (
                  "Nothing to show yet!"
                )}
              </label>
            </div>

            {/* Disaplay module content here */}
            <div
              dangerouslySetInnerHTML={{
                __html:
                  moduleState.singleModuleData?.data &&
                  moduleState.singleModuleData?.data.description,
              }}
            />
          </div>
        </div>

{/* </CoursePage> */}
      </div>
      <Footer />
      <MobileFooter/>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { moduleState: state.courses.singleModule };
};

const mapDispatchToProps = { viewSpecificModuleAction };

export default connect(mapStateToProps, mapDispatchToProps)(ModulePage);
